import {createClient} from "contentful";

export const contentfulClient = createClient({
  space: 'p4px7ui043a6',
  accessToken: 'QffZQT-ihzth3w8oiM-ov9qvwPOv9Y9gUacvzOorUf0',
})
